import(/* webpackMode: "eager" */ "/var/www/baansindhorn.com-docker/app/(withLayout)/residence/page.tsx");
